import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import DriveFileRenameOutlineRounded from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { useUpdateContentModelMutation } from "../../../../../shell/services/instance";
import { ContentModel } from "../../../../../shell/services/types";
import { notify } from "../../../../../shell/store/notifications";
import { useDispatch } from "react-redux";
import { SelectModelParentInput } from "./SelectModelParentInput";
import { useTranslation } from "react-i18next";
interface Props {
  onClose: () => void;
  model: ContentModel;
}
export const UpdateParentModelDialogue = ({
  onClose,
  model
}: Props) => {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [newParentZUID, setNewParentZUID] = useState(model.parentZUID === "0" ? null : model.parentZUID);
  const [updateModel, {
    isLoading,
    isSuccess,
    error
  }] = useUpdateContentModelMutation();
  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess]);
  useEffect(() => {
    if (error) {
      const message = "data" in error ? (error.data as any)?.error : undefined;
      dispatch(notify({
        message: message || t("schema.updateDescriptionFailedNotify"),
        kind: "warn"
      }));
    }
  }, [error]);
  return <Dialog open onClose={onClose} fullWidth maxWidth="xs" data-sentry-element="Dialog" data-sentry-component="UpdateParentModelDialogue" data-sentry-source-file="UpdateParentModelDialogue.tsx">
      <DialogTitle component="div" data-sentry-element="DialogTitle" data-sentry-source-file="UpdateParentModelDialogue.tsx">
        <Box sx={{
        backgroundColor: "blue.50",
        borderRadius: "100%",
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }} data-sentry-element="Box" data-sentry-source-file="UpdateParentModelDialogue.tsx">
          <DriveFileRenameOutlineRounded color="info" data-sentry-element="DriveFileRenameOutlineRounded" data-sentry-source-file="UpdateParentModelDialogue.tsx" />
        </Box>
        <Typography variant="h5" fontWeight={700} mt={1.5} data-sentry-element="Typography" data-sentry-source-file="UpdateParentModelDialogue.tsx">
          {t("schema.updateParentDialogTitle")}
        </Typography>
        <Typography variant="body2" sx={{
        mt: 1
      }} color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="UpdateParentModelDialogue.tsx">
          {t("schema.updateParentDialogBody")}
        </Typography>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="UpdateParentModelDialogue.tsx">
        <SelectModelParentInput modelType={model.type} value={newParentZUID} onChange={value => setNewParentZUID(value)} tooltip={t("schema.updateParentInputTooltip")} data-sentry-element="SelectModelParentInput" data-sentry-source-file="UpdateParentModelDialogue.tsx" />
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="UpdateParentModelDialogue.tsx">
        <Button onClick={onClose} color="inherit" data-sentry-element="Button" data-sentry-source-file="UpdateParentModelDialogue.tsx">
          {t("common.cancel")}
        </Button>
        <Button onClick={() => updateModel({
        ZUID: model.ZUID,
        body: {
          parentZUID: newParentZUID || "0"
        }
      })} loading={isLoading} variant="contained" data-sentry-element="Button" data-sentry-source-file="UpdateParentModelDialogue.tsx">
          {t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>;
};